import { render } from "./Facebook.vue?vue&type=template&id=6437eedc"
const script = {}
script.render = render

export default script